document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initContador();
  initGaleriaProducto();
  initSelectorVariantes();
  initLightboxProducto();
  initStickyCTA();
  initCountdownSemanal();
});

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initContador() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
      var dur = 1200;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / dur, 1);
        var valor = Math.floor(progreso * fin);
        el.textContent = valor.toLocaleString('en-US');
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin.toLocaleString('en-US');
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function construirItemsGaleria(wrap) {
  var items = [];
  wrap.querySelectorAll('[data-mt-thumb]').forEach(function (thumb) {
    var img = thumb.querySelector('img');
    items.push({
      tipo: thumb.getAttribute('data-tipo') || 'imagen',
      videoSrc: thumb.getAttribute('data-video-src') || '',
      full: thumb.getAttribute('data-full'),
      fullGrande: thumb.getAttribute('data-full-grande') || thumb.getAttribute('data-full'),
      alt: img ? img.alt : ''
    });
  });
  return items;
}

function actualizarMiniaturaActiva(wrap, indice) {
  wrap.querySelectorAll('[data-mt-thumb]').forEach(function (thumb, i) {
    thumb.style.borderColor = i === indice ? 'var(--mt-color-acento)' : 'rgba(22,32,46,0.15)';
  });
}

function initArrastreHorizontal(el, onSwipe) {
  var inicioX = null;
  var inicioY = null;
  el.addEventListener('pointerdown', function (evt) {
    inicioX = evt.clientX;
    inicioY = evt.clientY;
  });
  el.addEventListener('pointerup', function (evt) {
    if (inicioX === null) return;
    var deltaX = evt.clientX - inicioX;
    var deltaY = evt.clientY - (inicioY || 0);
    if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
      onSwipe(deltaX < 0 ? 1 : -1);
    }
    inicioX = null;
    inicioY = null;
  });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var wrap = galeria.closest('.mt-container');
    if (!wrap) return;
    var items = construirItemsGaleria(wrap);
    if (!items.length) return;
    var mainImg = galeria.querySelector('[id^="mt-img-actual-"]');
    var mainVideo = galeria.querySelector('[id^="mt-video-actual-"]');
    var indiceActual = 0;
    items.forEach(function (item, i) { if (item.full === mainImg.getAttribute('src')) indiceActual = i; });

    function mostrar(indice) {
      indiceActual = ((indice % items.length) + items.length) % items.length;
      var item = items[indiceActual];
      if (item.tipo === 'video') {
        if (mainVideo) {
          mainVideo.pause();
          mainVideo.src = item.videoSrc;
          mainVideo.style.display = '';
        }
        mainImg.style.display = 'none';
      } else {
        if (mainVideo) { mainVideo.pause(); mainVideo.style.display = 'none'; }
        mainImg.style.display = '';
        mainImg.src = item.full;
        mainImg.dataset.full = item.fullGrande;
        if (item.alt) mainImg.alt = item.alt;
      }
      actualizarMiniaturaActiva(wrap, indiceActual);
      var seccion = wrap.closest('section');
      var lightbox = seccion ? seccion.querySelector('[data-mt-lightbox]') : null;
      if (lightbox && lightbox.style.display === 'flex') {
        mostrarEnLightbox(lightbox, item);
      }
    }

    galeria.__mtMostrar = mostrar;
    galeria.__mtIndiceActual = function () { return indiceActual; };
    galeria.__mtItems = items;

    var prevBtn = galeria.querySelector('[data-mt-galeria-prev]');
    var nextBtn = galeria.querySelector('[data-mt-galeria-next]');
    if (prevBtn) prevBtn.addEventListener('click', function (evt) { evt.stopPropagation(); mostrar(indiceActual - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function (evt) { evt.stopPropagation(); mostrar(indiceActual + 1); });

    initArrastreHorizontal(galeria, function (direccion) { mostrar(indiceActual + direccion); });

    wrap.querySelectorAll('[data-mt-thumb]').forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        mostrar(i);
        abrirMtLightbox(wrap, items[i], galeria);
      });
    });

    actualizarMiniaturaActiva(wrap, indiceActual);
  });
}

function mostrarEnLightbox(lightbox, item) {
  var img = lightbox.querySelector('[data-mt-lightbox-img]');
  var video = lightbox.querySelector('[data-mt-lightbox-video]');
  if (item.tipo === 'video') {
    if (video) {
      video.pause();
      video.src = item.videoSrc;
      video.style.display = '';
    }
    if (img) img.style.display = 'none';
  } else {
    if (video) { video.pause(); video.style.display = 'none'; }
    if (img) {
      img.style.display = '';
      img.src = item.fullGrande;
      img.alt = item.alt || '';
    }
  }
}

function abrirMtLightbox(scope, item, galeria) {
  var lightbox = (scope.closest('section') || document).querySelector('[data-mt-lightbox]') || document.querySelector('[data-mt-lightbox]');
  if (!lightbox) return;
  mostrarEnLightbox(lightbox, item);
  lightbox.__mtGaleria = galeria || lightbox.__mtGaleria;
  lightbox.style.display = 'flex';
  lightbox.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function cerrarMtLightbox(lightbox) {
  lightbox.style.display = 'none';
  lightbox.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
  var video = lightbox.querySelector('[data-mt-lightbox-video]');
  if (video) video.pause();
}

function initLightboxProducto() {
  document.querySelectorAll('[data-mt-zoom-abrir]').forEach(function (zonaZoom) {
    zonaZoom.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-mt-galeria-prev], [data-mt-galeria-next]')) return;
      var wrap = zonaZoom.closest('.mt-container');
      if (!wrap) return;
      var indice = zonaZoom.__mtIndiceActual ? zonaZoom.__mtIndiceActual() : 0;
      var item = zonaZoom.__mtItems ? zonaZoom.__mtItems[indice] : null;
      if (!item) {
        var mainImg = zonaZoom.querySelector('img');
        if (!mainImg) return;
        item = { tipo: 'imagen', full: mainImg.src, fullGrande: mainImg.dataset.full || mainImg.src, alt: mainImg.alt };
      }
      abrirMtLightbox(wrap, item, zonaZoom);
    });
  });

  document.querySelectorAll('[data-mt-lightbox]').forEach(function (lightbox) {
    var cerrarBtn = lightbox.querySelector('[data-mt-lightbox-cerrar]');
    if (cerrarBtn) cerrarBtn.addEventListener('click', function () { cerrarMtLightbox(lightbox); });
    var prevBtn = lightbox.querySelector('[data-mt-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-mt-lightbox-next]');
    if (prevBtn) prevBtn.addEventListener('click', function (evt) {
      evt.stopPropagation();
      if (lightbox.__mtGaleria && lightbox.__mtGaleria.__mtMostrar) lightbox.__mtGaleria.__mtMostrar(lightbox.__mtGaleria.__mtIndiceActual() - 1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function (evt) {
      evt.stopPropagation();
      if (lightbox.__mtGaleria && lightbox.__mtGaleria.__mtMostrar) lightbox.__mtGaleria.__mtMostrar(lightbox.__mtGaleria.__mtIndiceActual() + 1);
    });
    initArrastreHorizontal(lightbox, function (direccion) {
      if (lightbox.__mtGaleria && lightbox.__mtGaleria.__mtMostrar) lightbox.__mtGaleria.__mtMostrar(lightbox.__mtGaleria.__mtIndiceActual() + direccion);
    });
    document.addEventListener('keydown', function (evt) {
      if (lightbox.style.display !== 'flex') return;
      if (evt.key === 'ArrowRight' && lightbox.__mtGaleria) lightbox.__mtGaleria.__mtMostrar(lightbox.__mtGaleria.__mtIndiceActual() + 1);
      if (evt.key === 'ArrowLeft' && lightbox.__mtGaleria) lightbox.__mtGaleria.__mtMostrar(lightbox.__mtGaleria.__mtIndiceActual() - 1);
    });
    lightbox.addEventListener('click', function (evt) {
      if (evt.target === lightbox) cerrarMtLightbox(lightbox);
    });
    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && lightbox.style.display === 'flex') cerrarMtLightbox(lightbox);
    });
  });
}

function initSelectorVariantes() {
  document.querySelectorAll('[data-mt-variant-form]').forEach(function (form) {
    var sectionRoot = form.closest('.mt-section');
    if (!sectionRoot) return;
    var jsonScript = sectionRoot.querySelector('script[id^="mt-variantes-"]');
    if (!jsonScript) return;
    var variantes;
    try { variantes = JSON.parse(jsonScript.textContent); } catch (e) { return; }

    var stockScript = sectionRoot.querySelector('script[id^="mt-stock-real-"]');
    var stockReal = {};
    if (stockScript) { try { stockReal = JSON.parse(stockScript.textContent); } catch (e) { stockReal = {}; } }

    var precioEl = sectionRoot.querySelector('[id^="mt-precio-actual-"]');
    var precioComparadoEl = sectionRoot.querySelector('[id^="mt-precio-comparado-"]');
    var precioStickyEl = sectionRoot.querySelector('[id^="mt-precio-sticky-"]');
    var hiddenIdInput = sectionRoot.querySelector('.product-variant-id');
    var submitBtn = sectionRoot.querySelector('product-form [type="submit"]');
    var submitBtnText = submitBtn ? submitBtn.querySelector('span') : null;
    var estadoStock = sectionRoot.querySelector('[id^="mt-estado-stock-"]');
    var stockMsgEl = sectionRoot.querySelector('[id^="mt-stock-msg-"]');
    var stockCantidadEl = sectionRoot.querySelector('[id^="mt-stock-cantidad-"]');
    var stockUmbral = parseInt(form.getAttribute('data-stock-umbral'), 10) || 200;
    var currency = precioEl ? precioEl.getAttribute('data-currency') : 'USD';
    var formatter;
    try { formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }); } catch (e) { formatter = null; }

    function formatear(centavos) {
      var valor = centavos / 100;
      return formatter ? formatter.format(valor) : valor.toFixed(2);
    }

    function opcionesSeleccionadas() {
      var seleccion = {};
      form.querySelectorAll('[data-mt-opcion]').forEach(function (select) {
        seleccion[select.getAttribute('data-mt-opcion')] = select.value;
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = opcionesSeleccionadas();
      return variantes.find(function (variante) {
        return variante.options.every(function (valor, indice) {
          var nombreOpcion = Object.keys(seleccion)[indice];
          return !nombreOpcion || seleccion[nombreOpcion] === valor;
        });
      });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;

      if (hiddenIdInput) hiddenIdInput.value = variante.id;
      if (precioEl) precioEl.textContent = formatear(variante.price);
      if (precioStickyEl) precioStickyEl.textContent = formatear(variante.price);
      if (precioComparadoEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioComparadoEl.textContent = formatear(variante.compare_at_price);
          precioComparadoEl.style.display = '';
        } else {
          precioComparadoEl.style.display = 'none';
        }
      }

      var disponible = variante.available;
      if (submitBtn) {
        submitBtn.disabled = !disponible;
        submitBtn.toggleAttribute('aria-disabled', !disponible);
      }
      if (submitBtnText) submitBtnText.textContent = disponible ? (window.variantStrings ? window.variantStrings.addToCart : 'Add to cart') : 'Sold out';
      if (estadoStock) estadoStock.textContent = disponible ? '' : 'This combination is currently out of stock.';

      if (stockMsgEl && stockCantidadEl) {
        var cantidadReal = stockReal[variante.id];
        if (variante.inventory_management === 'shopify' && typeof cantidadReal === 'number' && cantidadReal <= stockUmbral) {
          stockCantidadEl.textContent = cantidadReal;
          stockMsgEl.style.display = 'inline-flex';
        } else {
          stockMsgEl.style.display = 'none';
        }
      }

      form.querySelectorAll('[data-mt-opcion-valor]').forEach(function (span, indice) {
        var select = form.querySelectorAll('[data-mt-opcion]')[indice];
        if (select) span.textContent = select.value;
      });
    }

    form.querySelectorAll('[data-mt-opcion]').forEach(function (select) {
      select.addEventListener('change', actualizar);
    });

    var familyCheckbox = sectionRoot.querySelector('[data-mt-family-pack]');
    var quantityInput = sectionRoot.querySelector('.mt-quantity-input');
    var colorSelect = form.querySelector('[data-mt-opcion="Color"]');

    function aplicarEstadoFamilyPack() {
      if (!familyCheckbox) return;
      if (familyCheckbox.checked) {
        var esMarron = colorSelect && colorSelect.value.indexOf('Brown') === 0;
        var varianteObjetivoId = esMarron
          ? familyCheckbox.getAttribute('data-variante-marron')
          : familyCheckbox.getAttribute('data-variante-negro');
        if (!varianteObjetivoId) return;
        var variante = variantes.find(function (v) { return String(v.id) === String(varianteObjetivoId); });
        if (!variante) return;
        if (hiddenIdInput) hiddenIdInput.value = variante.id;
        if (quantityInput) quantityInput.value = '2';
        if (precioEl) precioEl.textContent = formatear(variante.price * 2) + ' for 2 pairs';
        if (precioStickyEl) precioStickyEl.textContent = formatear(variante.price * 2) + ' (2 pairs)';
        if (precioComparadoEl) precioComparadoEl.style.display = 'none';
        if (submitBtnText) submitBtnText.textContent = 'Add Family Pack to cart';
      } else {
        if (quantityInput) quantityInput.value = '1';
        actualizar();
      }
    }

    if (familyCheckbox) {
      familyCheckbox.addEventListener('change', aplicarEstadoFamilyPack);
    }
    if (colorSelect && familyCheckbox) {
      colorSelect.addEventListener('change', function () {
        if (familyCheckbox.checked) aplicarEstadoFamilyPack();
      });
    }
  });
}

function initCountdownSemanal() {
  document.querySelectorAll('[id^="mt-countdown-"]').forEach(function (el) {
    function proximoDomingo() {
      var ahora = new Date();
      var fin = new Date(ahora);
      var diasHastaDomingo = (7 - ahora.getDay()) % 7;
      fin.setDate(ahora.getDate() + diasHastaDomingo);
      fin.setHours(23, 59, 59, 999);
      if (fin <= ahora) fin.setDate(fin.getDate() + 7);
      return fin;
    }
    function actualizarCountdown() {
      var restante = proximoDomingo().getTime() - Date.now();
      if (restante < 0) restante = 0;
      var horas = Math.floor(restante / 3600000);
      var minutos = Math.floor((restante % 3600000) / 60000);
      var segundos = Math.floor((restante % 60000) / 1000);
      function dosDigitos(n) { return String(n).padStart(2, '0'); }
      el.textContent = dosDigitos(horas) + ':' + dosDigitos(minutos) + ':' + dosDigitos(segundos);
    }
    actualizarCountdown();
    setInterval(actualizarCountdown, 1000);
  });
}

function initStickyCTA() {
  document.querySelectorAll('[data-mt-sticky-cta]').forEach(function (barra) {
    var sectionRoot = barra.closest('.mt-section');
    if (!sectionRoot) return;
    var submitBtn = sectionRoot.querySelector('product-form [type="submit"]');
    var stickyBtn = barra.querySelector('[data-mt-sticky-add]');
    if (!submitBtn || !stickyBtn) return;

    stickyBtn.addEventListener('click', function () {
      submitBtn.click();
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        barra.classList.toggle('mt-producto__sticky--visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(submitBtn);
  });
}
